import { CloseOutlined } from '@ant-design/icons';
import { message } from 'antd';
import i18n from '../i18n';

const DURATION_UNTIL_CLOSED = 0;
const DURATION_AUTO_DISMISS_SECONDS = 3;
const PERSISTENT_MESSAGE_CLASS = 'persistent-message-toast';

const getPersistentMessageOptions = (content) => ({
  content,
  duration: DURATION_UNTIL_CLOSED,
  closable: true,
  className: PERSISTENT_MESSAGE_CLASS,
  closeIcon: (
    <span className="persistent-message-close-control" title={i18n.t('common.close')}>
      <CloseOutlined className="persistent-message-close-icon" />
      <span className="persistent-message-close-label">{i18n.t('common.close')}</span>
    </span>
  ),
});

const notify = {
  success: (content) => message.success({ content, duration: DURATION_AUTO_DISMISS_SECONDS }),
  error: (content) => message.error(getPersistentMessageOptions(content)),
  warning: (content) => message.warning(getPersistentMessageOptions(content)),
  info: (content) => message.info(getPersistentMessageOptions(content)),
};

export default notify;
